import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { BusinessCardQueryParams } from '@warema/shared/company-search/models';
import { QrCodeComponent } from '@warema/shared/components';
import { BusinessCardOverviewDataDto } from '@warema/shared/models';
import { BusinessCardUrlWithParamsPipe } from '@warema/shared/pipes';
import { SharedSvgModule } from '@warema/shared/svg';
import { PopupContent, WaremaButton } from '@warema/warema-ui-angular';
import { BusinessCardBadgesComponent } from '../business-card-badges/business-card-badges.component';
import { BusinessCardOpeningTimesComponent } from '../business-card-opening-times/business-card-opening-times.component';

@Component({
    selector: 'warema-business-card-popup',
    imports: [
        WaremaButton,
        TranslatePipe,
        SharedSvgModule,
        QrCodeComponent,
        BusinessCardBadgesComponent,
        BusinessCardOpeningTimesComponent,
        BusinessCardUrlWithParamsPipe,
    ],
    templateUrl: './business-card-popup.component.html',
    styleUrls: ['./business-card-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BusinessCardPopupComponent extends PopupContent<boolean> {
    public readonly businessCardPreview = input.required<BusinessCardOverviewDataDto>();
    public readonly params = input.required<BusinessCardQueryParams>();
}
